var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconInvoicing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.048 19.531c4.003 0 7.248-3.432 7.248-7.665 0-4.234-3.245-7.666-7.248-7.666-4.004 0-7.249 3.432-7.249 7.666 0 4.233 3.245 7.665 7.249 7.665z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.297 8.428h-2.874c-.898 0-1.625.77-1.625 1.718 0 .95.727 1.718 1.625 1.718h1.25c.897 0 1.624.77 1.624 1.719 0 .949-.727 1.718-1.624 1.718H9.798M12.048 7.371V7.9M12.048 15.83v.528",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconInvoicing);
export default __webpack_public_path__ + "static/media/nav-icon-invoicing.baf3c641a0212f82a9361cb3eb9f41d4.svg";
export { ForwardRef as ReactComponent };